import ArrowDown from '../../src/legacy/ArrowDown.tsx';
export default ArrowDown;
